import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Checkbox from '@veeva/corgix/checkbox';
import useMessageService from '../services/i18n/useMessageService';

const propTypes = {
    legalNameVerified: PropTypes.bool,
    onChange: PropTypes.func,
};

const LegalNameVerification = ({ legalNameVerified, onChange }) => {
    const [
        [
            changeAuthorizedConfirmationMessage,
            providedNamesAreLegalNamesMessage,
            namesMatchOfficialIdMessage,
        ],
    ] = useMessageService([
        'my_account.change_authorized_confirmation',
        'my_account.provided_names_are_legal_names',
        'my_account.names_match_official_id',
    ]);

    const handleChange = (_, value) => {
        onChange?.(value);
    };

    const checkboxContainerCSS = css`
        > span {
            align-items: flex-start;
        }
    `;

    return (
        <div
            css={({ orangeDarkest, orangeLightest, black }) => css`
                box-sizing: border-box;
                width: 100%;
                padding: 1.6667rem;
                display: flex;
                flex-direction: column;
                gap: 0.6667rem;
                border-radius: 8px;
                border: solid 1px ${orangeDarkest};
                background-color: ${orangeLightest};
                font-size: 1rem;
                color: ${black};
                text-align: start;
            `}
        >
            <div css={checkboxContainerCSS}>
                <Checkbox
                    checked={legalNameVerified}
                    onChange={handleChange}
                    label={
                        <p
                            css={css`
                                margin: 1px 0 0 0;
                            `}
                        >
                            {changeAuthorizedConfirmationMessage}
                        </p>
                    }
                />
            </div>
            <ul
                css={css`
                    margin: 0;
                    padding-left: 1.6667rem;

                    li::marker {
                        font-size: 1rem;
                    }
                `}
            >
                <li>{providedNamesAreLegalNamesMessage}</li>
                <li>{namesMatchOfficialIdMessage}</li>
            </ul>
        </div>
    );
};

LegalNameVerification.propTypes = propTypes;
export default LegalNameVerification;
